import { Box, HStack, Tooltip, useRadioGroup } from '@chakra-ui/react';
import { FC, useEffect } from 'react';
import { GiAmericanFootballHelmet } from 'react-icons/gi';
import { LuImage } from 'react-icons/lu';
import RadioCard from './RadioCard';
import { CasinoIcon } from '@adflow/editor/src/icons/casino';

const imgElOptions = [
  { value: 'img', label: 'Image' },
  { value: 'teamasset', label: 'Team Asset' },
  { value: 'casino', label: 'Casino' },
];

export type ImgElType = 'img' | 'teamasset' | 'casino';

const ImgElTypeRadioGroup: FC<{
  name: string;
  val?: ImgElType;
  onChange: (val: ImgElType) => void;
  casinoTemplatesEnabled?: boolean;
}> = ({ name, val, onChange, casinoTemplatesEnabled }) => {
  const { getRootProps, getRadioProps, setValue } = useRadioGroup({
    name,
    defaultValue: 'img',
    onChange,
  });

  useEffect(() => {
    if (val) {
      setValue(val);
    }
  }, [setValue, val]);

  const group = getRootProps();

  return (
    <HStack {...group} marginRight={2} data-test-id="element-options">
      {imgElOptions
        .filter(({ value }) => casinoTemplatesEnabled || value !== 'casino')
        .map(({ value, label }) => {
          const radio = getRadioProps({ value });
          return (
            <Tooltip label={label} key={value}>
              <Box>
                <RadioCard {...radio}>
                  {value === 'img' ? (
                    <LuImage />
                  ) : value === 'teamasset' ? (
                    <GiAmericanFootballHelmet />
                  ) : (
                    <CasinoIcon />
                  )}
                </RadioCard>
              </Box>
            </Tooltip>
          );
        })}
    </HStack>
  );
};

export default ImgElTypeRadioGroup;
